import React__default, { Suspense } from 'react';
import { E as ErrorBoundary } from './ErrorBoundary-BK_7TY1I-BK_7TY1I.js';
import { I as InternalIntlProvider } from './Provider-DZ_dmGP_-CY6AX8uq.js';

function isDynamicComponent(translations) {
  return 'translationImports' in translations && translations.translationImports;
}
function IntlProvider({
  children,
  resetKey,
  fallback = null,
  translations,
  onError,
  onReset
}) {
  return isDynamicComponent(translations) ? /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    resetKey: resetKey,
    onError: onError,
    onReset: onReset
  }, /*#__PURE__*/React__default.createElement(Suspense, {
    fallback: fallback !== null && fallback !== void 0 ? fallback : null
  }, /*#__PURE__*/React__default.createElement(InternalIntlProvider, {
    translations: translations
  }, children))) : /*#__PURE__*/React__default.createElement(InternalIntlProvider, {
    translations: translations
  }, children);
}

export { IntlProvider as I };
//# sourceMappingURL=IntlProvider-DmRs8GLp-yq9BpgTU.js.map
